<div class="workflow" [resBusySpinner]="isBusy" [message]="busyMessage"
    data-automation-id="workflow-step-panel-container">
    <form [formGroup]="contentForm" novalidate (ngSubmit)="saveChangesWithPromise()">
        <div class="top-row">
            <div class="button-bar">
                <span [(resScrollablePopover)]="showMetadataPopover" popoverPlacement="bottom" [isSingleLine]="true"
                    [popoverOffsetTop]="1" [popoverOffsetLeft]="25" [popoverType]="'error'"
                    [popoverErrorMessage]="metadataPopoverText" [popoverAutomation]="'workflow-metadata-popover'">
                    <button type="submit" class="primary-button" [disabled]="!contentForm.dirty"
                        *ngIf="hasCreatePermissions" data-automation-id="workflow-step-panel-save-button">Save</button>
                </span>
                <button type="button" class="secondary-button discard" [disabled]="!contentForm.dirty"
                    (click)="discardChanges()" data-automation-id="workflow-step-panel-discard-changes-button"
                    *ngIf="hasCreatePermissions">Discard
                    Changes</button>
                <button type="button" class="secondary-button validate"
                    [disabled]="contentForm.dirty || !hasNonEmptyStep() || isRunning() || !workflow.dataSetItem || !workflow.dataSetItem.name"
                    (click)="validate()" data-automation-id="workflow-step-panel-validate-button"
                    [resScrollablePopover]="showValidationPopover && !contentForm.dirty" popoverPlacement="bottom"
                    [isSingleLine]="true" [popoverOffsetTop]="1" [popoverOffsetLeft]="-10" [popoverType]="popoverType"
                    [popoverErrorMessage]="validityText" [popoverAutomation]="'workflow-validation-popover'"><i
                        class="fa fa-check"></i>Validate</button>
                <button type="button" class="primary-button run-button"
                    [disabled]="!isValid || isRunning() || contentForm.dirty || queriesChanged" (click)="run()"
                    [ngClass]="isRunning() ? 'running' : ''" data-automation-id="workflow-step-panel-run-button">
                    <i class="fa" [ngClass]="isRunning() ? 'fa-spinner fa-spin' : 'fa-play'"></i>
                    {{isRunning() ? 'Running' : 'Run ...'}}
                </button>
                <span *ngIf="!isRunning()" data-automation-id="LAST_RAN_LABEL">Last ran:
                    {{workflow.lastExecutedOn ? (workflow.lastExecutedOn | date:'yyyy-MM-dd HH:mm:ss') :
                    'Never'}}</span>
                <span [hidden]="!isRunning()">{{getCompletion() + '% complete'}}</span>
            </div>
            <div class="right-bar">
                <div class="button-group" [hidden]="isRunning()">
                    <li class="dropdown" dropdown>
                        <button dropdownToggle type="button" class="secondary-button" [disabled]="contentForm.dirty"
                            data-automation-id="workflow-step-panel-workflow-option-dropdown">
                            <i class="fa fa-list-ol"></i>
                            <span class="workflow-button">Workflow</span>
                            <i class="fa fa-caret-down"></i>
                        </button>
                        <ul *dropdownMenu class="dropdown-menu">
                            <li (click)="saveToTemplate()" class="menu-item"
                                data-automation-id="workflow-save-to-template-button" *ngIf="hasCreatePermissions"
                                [ngClass]="[!workflow.lockedBy ? '' : 'disabled']">
                                <label>
                                    <i class="fa fa-save menu-item-icon color-blue-01"></i>
                                </label>
                                <div class="optionContainer">
                                    <div class="option-name">Save to Template ...</div>
                                </div>
                            </li>
                            <li class="disabled divider dropdown-divider"></li>
                            <li (click)="copy()" class="menu-item" data-automation-id="workflow-copy-button"
                                *ngIf="hasCreatePermissions">
                                <label>
                                    <i class="fa fa-copy menu-item-icon color-grey-10"></i>
                                </label>
                                <div class="optionContainer">
                                    <div class="option-name">Copy ...</div>
                                </div>
                            </li>
                            <li *ngIf="!workflow.lockedBy && hasLockPermissions" [disabled]="true"
                                (click)="lock('Lock')" class="menu-item" [ngClass]="[isLockable() ? '' : 'disabled']"
                                data-automation-id="workflow-lock-button">
                                <label>
                                    <i class="fa fa-lock menu-item-icon color-grey-10"></i>
                                </label>
                                <div class="optionContainer">
                                    <div class="option-name">Lock</div>
                                </div>
                            </li>
                            <li *ngIf="workflow.lockedBy && hasLockPermissions" (click)="lock('Unlock')"
                                class="menu-item" data-automation-id="workflow-unlock-button">
                                <label>
                                    <i class="fa fa-unlock menu-item-icon color-grey-10"></i>
                                </label>
                                <div class="optionContainer">
                                    <div class="option-name">Unlock</div>
                                </div>
                            </li>
                            <li class="disabled divider dropdown-divider"></li>
                            <li (click)="edit()" class="menu-item" data-automation-id="workflow-edit-button"
                                *ngIf="hasCreatePermissions" [ngClass]="[!workflow.lockedBy ? '' : 'disabled']">
                                <label>
                                    <i class="fa fa-pencil menu-item-icon color-blue-01"></i>
                                </label>
                                <div class="optionContainer">
                                    <div class="option-name">Edit ...</div>
                                </div>
                            </li>
                            <li (click)="delete()" class="menu-item" data-automation-id="workflow-delete-button"
                                *ngIf="hasDeletePermissions" [ngClass]="[!workflow.lockedBy ? '' : 'disabled']">
                                <label>
                                    <i class="fa fa-trash menu-item-icon color-red-05"></i>
                                </label>
                                <div class="optionContainer">
                                    <div class="option-name">Delete</div>
                                </div>
                            </li>
                        </ul>
                    </li>
                </div>
                <button type="button" class="help-button" data-automation-id="workflow-step-panel-help-button"
                    (click)="openHelp()">
                    <i class="fa fa-question"></i>
                </button>
            </div>
        </div>
        <div class="name-line">
            <span class="workflow-name">{{workflow.name}}</span>
            <i class="fa"
                [ngClass]="[(workflow.lockedBy || isRunning()) ? 'fa-lock' : 'fa-unlock', isLockable() && hasLockPermissions ? '' : 'greylock']"
                title="{{isRunning() ? 'Locked while running' : workflow.lockedBy ? 'Locked by ' + workflow.lockedBy : ''}}"
                [attr.data-automation-id]="workflow.lockedBy ? 'LOCK_ICON' : 'UNLOCK_ICON'"
                (click)="lock(workflow.lockedBy ? 'Unlock' : 'Lock')"></i>
            <i class="fa fa-check validworkflow" [hidden]="queriesChanged || !isValid" title="Valid"
                [attr.data-automation-id]="'VALID_ICON'"></i>
        </div>
        <span class="workflow-description" *ngIf="workflow.description">{{workflow.description}}</span>
        <div class="scroll-container" style="overflow-y: auto;">
            <div class="target-pane">
                <span>Initial Search Target:</span>
                <div class="target-picker" formGroupName="dataSetItem">
                    <input type="text"
                        title="{{contentForm.value.dataSetItem ? contentForm.value.dataSetItem.name : null}}" readonly
                        formControlName="name" data-automation-id="workflow-step-panel-project-data-input">
                    <button type="button" class="primary-button target-button"
                        [class.disabled]="workflow.lockedBy || isRunning()" (click)="launchPicker()"
                        data-automation-id="workflow-step-panel-select-target-button" *ngIf="hasCreatePermissions">
                        <i class="fa fa-crosshairs"></i>
                        <span>Select Target ...</span>
                    </button>
                </div>
            </div>

            <div formArrayName="queryItems">
                <div *ngFor="let step of queryItems.controls; let i = index" class="step item-container">
                    <div class="add-step">
                        <div class="add-step-wrapper">
                            <div class="arrow-box">
                                <i class="fa fa-arrow-down arrow-padding"
                                    data-automation-id="workflow-step-panel-arrow-icon"></i>
                            </div>
                            <div class="plus-box plus-margin" title="Add a New Step Here" (click)="addStep(i)"
                                data-automation-id="workflow-step-panel-add-new-step-button">
                                <i class="fa fa-plus"></i>
                            </div>
                        </div>
                    </div>
                    <res-workflow-step [workflowForm]="contentForm" [stepNumber]="i" [running]="isRunning()"
                        [locked]="!(!workflow.lockedBy) || isRunning()" [task]="searchTasks[i + 1]"
                        [workflowStep]="workflow.queryItems.items[i]" [validityResult]="validityResults[i]"
                        [addStep]="addStep.bind(this)" [removeStep]="removeStep.bind(this)"
                        [moveUp]="moveUp.bind(this)"
                        (stepChange)="onStepQueryChanged($event)"></res-workflow-step>
                </div>
            </div>
            <div class="results"
                *ngIf="searchTasks && searchTasks.length > 0 && !isRunning() && workflow.lastExecutedOn > workflow.modifiedOn">
                <div class="add-step result-step">
                    <div class="add-step-wrapper">
                        <div class="arrow-box">
                            <i class="fa fa-arrow-down arrow-padding"
                                data-automation-id="workflow-step-panel-arrow-icon"></i>
                        </div>
                        <div class="plus-box" title="Add a New Step Here" (click)="addStep(queryItems.controls.length)"
                            data-automation-id="workflow-step-panel-add-new-step-button">
                            <i class="fa fa-plus"></i>
                        </div>
                    </div>
                </div>
                <div class="results-row">
                    <span class="query-results link" (click)="navigateToResults()"
                        data-automation-id="RESULTS_LINK">{{workflow.resultCount | number}}
                        Results</span>
                    <span class="culled" data-automation-id="CULLED_LABEL">({{workflow.culledResults | number}}
                        culled)</span>
                </div>
            </div>
            <div class="tags-folders"
                [ngClass]="[searchTasks && searchTasks.length > 0 && !isRunning() && workflow.lastExecutedOn > workflow.modifiedOn ? '' : 'folder-top-margin']">
                <i class="fa fa-arrow-down"
                    *ngIf="searchTasks && searchTasks.length > 0 && !isRunning() && workflow.lastExecutedOn > workflow.modifiedOn"></i>
                <div class="add-step"
                    [hidden]="searchTasks && searchTasks.length > 0 && !isRunning() && workflow.lastExecutedOn > workflow.modifiedOn">
                    <div class="add-step-wrapper">
                        <div class="arrow-box">
                            <i class="fa fa-arrow-down arrow-padding"
                                data-automation-id="workflow-step-panel-arrow-icon"></i>
                        </div>
                        <div class="plus-box" title="Add a New Step Here" (click)="addStep(queryItems.controls.length)"
                            data-automation-id="workflow-step-panel-add-new-step-button">
                            <i class="fa fa-plus"></i>
                        </div>
                    </div>
                </div>
                <div class="horizontal-panels">
                    <div class="tag-panel">
                        <i class="fa fa-tags"></i>
                        <span class="disabled" *ngIf="!selectedTags || selectedTags.length === 0">No tags</span>
                        <div [attr.data-automation-id]="'tag-button-' + i" class="secondary-button"
                            *ngFor="let tag of selectedTags; index as i; trackBy: identify">
                            <i class="fa fa-tag iocnTag" [ngStyle]="{'color': tag.displayValue}"></i>
                            <div class="tagName"> {{tag.name}} </div>
                            <button type="button" class="clear-button" (click)="clearTag(i)"
                                *ngIf="hasCreatePermissions" [class.disabled]="workflow.lockedBy || isRunning()">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                        <button type="button" data-automation-id="TAGS_PLUS_BUTTON" class="secondary-button plus-button"
                            (click)="selectTag()" *ngIf="hasCreatePermissions && hasDocumentTagPermission"
                            [class.disabled]="workflow.lockedBy || isRunning()">
                            <i class="fa fa-plus"></i>
                        </button>
                    </div>
                    <div class="folder-panel">
                        <i class="fa fa-folder-open"></i>
                        <span class="disabled" *ngIf="!selectedFolder">No folder</span>
                        <div [attr.data-automation-id]="'folder-button'" class="secondary-button"
                            *ngIf="selectedFolder">
                            <i [ngClass]="['fa', selectedFolder.iconClass]"
                                [ngStyle]="{'color': selectedFolder.iconColor}"></i>
                            <div class="folderName"> {{selectedFolder.name}} </div>
                            <button type="button" class="clear-button" (click)="clearFolder()"
                                *ngIf="hasCreatePermissions" [class.disabled]="workflow.lockedBy || isRunning()">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                        <button *ngIf="!selectedFolder && hasCreatePermissions && hasDocumentFolderPermission"
                            type="button" data-automation-id="FOLDERS_PLUS_BUTTON" class="secondary-button plus-button"
                            (click)="selectFolder()" [class.disabled]="workflow.lockedBy || isRunning()">
                            <i class="fa fa-plus"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>